// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JCtF","type":"styles_type__1u93U","choices":"styles_choices__2Uh-C"};